import React from "react";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Poppers from "@material-ui/core/Popper";
import { useIdleTimer } from "react-idle-timer";
import PersonIcon from "@material-ui/icons/Person";
import { connect } from "react-redux";
import styles from "assets/jss/material-dashboard-react/components/headerLinksStyle";
import SessionOutModal from "views/Login/SessionOutModal";
import { Box, Typography } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { authLogout } from "Redux/Actions/LoginActions";
import { redirectToFronteggLogout } from "../../authSession";

// Applying custom styles using Material-UI's makeStyles
const useStyles = makeStyles(styles);

function AdminNavbarLinks(props) {
  const classes = useStyles();

  // Retrieving menu data and user details from localStorage
  const MenuData = JSON.parse(localStorage.getItem("menu") || "{}");
  const fistName = localStorage.getItem("fistName");
  const lastName = localStorage.getItem("lastName");

  // State variables for managing component behavior
  const [accessible, setAccessible] = React.useState(
    !localStorage.getItem("sendApiClientId")
      ? ""
      : JSON.parse(localStorage.getItem("sendApiClientId"))
  );
  const [openProfile, setOpenProfile] = React.useState(null);
  const [openModal, setOpenModal] = React.useState(false);
  const [remaining, setRemainingTime] = React.useState(0);
  const promptWindowSeconds = 120;

  // Handles the opening and closing of the profile dropdown
  const handleClickProfile = event => {
    if (openProfile && openProfile.contains(event.target)) {
      setOpenProfile(null);
    } else {
      setOpenProfile(event.currentTarget);
    }
  };

  const timeOutLimit = parseInt(process.env.REACT_APP_IDEAL_TIME_OUT);
  const idleTimeout = Number.isNaN(timeOutLimit) ? 600000 : timeOutLimit;
  const promptBeforeIdle = Math.min(promptWindowSeconds * 1000, Math.max(1000, idleTimeout - 1000));

  const idleTimer = useIdleTimer({
    startOnMount: true,
    timeout: idleTimeout,
    promptBeforeIdle,
    onPrompt: () => {
      setOpenModal(true);
    },
    onIdle: () => {
      setOpenModal(false);
      logoutFun();
    },
    debounce: 500,
  });

  React.useEffect(() => {
    if (!openModal) {
      setRemainingTime(0);
      return undefined;
    }

    const updateRemaining = () => {
      const remainingTime = Math.max(0, Math.ceil(idleTimer.getRemainingTime() / 1000));
      setRemainingTime(remainingTime);
    };

    updateRemaining();
    const countdown = setInterval(updateRemaining, 1000);

    return () => clearInterval(countdown);
  }, [openModal, idleTimer]);

  // Closes the session timeout modal and fully re-arms the idle timer.
  // activate() clears the internal prompted/idle state so onPrompt fires again
  // on every subsequent cycle, not just the first one.
  const closeModal = () => {
    setOpenModal(false);
    idleTimer.activate();
  };

  // IdleTimer handles all timeout logic internally.
  // The library fires onIdle callback automatically when timeout is reached.
  // No custom polling needed - this was defeating IdleTimer's built-in timing system.

  // ===== OPTION B: Centralized logout action =====
  // Logs out the user and performs cleanup actions atomically
  const logoutFun = () => {
    if (window.location.pathname === "/admin/user") {
      document.getElementById("saveDraftBusinessForm").click();
    }
    props.setState();
    localStorage.setItem(
      "idealPath",
      JSON.stringify({
        path: window.location.pathname,
        landingPageName: props.app,
      })
    );
    // Dispatch centralized logout action instead of manual cleanup
    if (props.authLogout) {
      props.authLogout(); // Centralized logout that clears everything atomically
    } else {
      // Fallback for backward compatibility
      props.logout();
    }
    setAccessible("");
    props.setOroviderListEmpty();
    props.resetReducer();
    redirectToFronteggLogout();
  };

  // Checks the user's profile type
  const profileTypeCheck = props.userRole.userList
    && props.userRole.userList.Role_Permission_Data
    && props.userRole.userList.Role_Permission_Data.Profile_Code;

  // Effect to handle user provider data and update state
  React.useEffect(() => {
    if (!props.userProvider.userProvider && !props.userProvider.loading) {
      // props.getUserListProvider();
    } else if (
      accessible === ""
      && props.userProvider.userProvider
      && !props.userProvider.loading
      && !localStorage.getItem("sendApiClientId")
    ) {
      const value = [];
      props.userProvider.userProvider.data.forEach(v => {
        value.push(v.Porvider_Id);
      });
      localStorage.setItem("sendApiClientId", JSON.stringify(value));
      setAccessible(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  // ===== OPTION B: Centralized logout without SDK dependency =====
  // Handles profile dropdown close and performs logout actions
  const handleCloseProfile = () => {
    props.setState();
    // Use centralized logout action
    if (props.authLogout) {
      props.authLogout(); // Centralized logout that clears everything atomically
    } else {
      // Fallback for backward compatibility
      props.logout();
    }
    setAccessible("");
    props.setOroviderListEmpty();
    props.resetReducer();
    redirectToFronteggLogout();
  };

  // Cleans up the user's name by removing undefined parts
  const cleanName = name => {
    const nameParts = name?.split(" ");
    const cleanedNameParts = nameParts?.filter(part => part.toLowerCase() !== "undefined");
    return cleanedNameParts?.join(" ");
  };

  // Retrieves the display name for the user
  const displayName = cleanName(MenuData?.Role_Permission_Data?.UserName);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      {/* Profile section with user details */}
      <Box
        onClick={handleClickProfile}
        style={{
          cursor: "pointer",
          display: "flex",
          borderRadius: "24px",
          backgroundColor: "#EFF4FF",
          padding: "8px 12px",
        }}
      >
        <Box style={{ padding: "8px", display: "flex", alignItems: "center" }}>
          <Typography
            style={{
              fontSize: "16px",
              fontWight: "600",
              lineHeight: "22px",
              color: "#333333",
            }}
          >
            {fistName || displayName}
            {" "}
            {lastName}
          </Typography>
        </Box>
        <Box style={{ padding: "8px", display: "flex", alignItems: "center" }}>
          <KeyboardArrowDownIcon />
        </Box>
        <Box style={{ display: "flex", alignItems: "center" }}>
          {profileTypeCheck === "SA" && (
            <>
              {props.userProvider.profileImage
                && props.userProvider.profileImage.Users_Data[0]
                  .User_Profile_Image !== "" ? (
                <img
                  alt="UserImage"
                  style={{
                    borderRadius: "50%",
                    height: "40px",
                    width: "40px",
                  }}
                  src={
                    props.userProvider.profileImage
                    && props.userProvider.profileImage.Users_Data[0]
                      .User_Profile_Image.File_Path
                  }
                />
              ) : (
                <PersonIcon />
              )}
            </>
          )}
        </Box>
      </Box>

      {/* Profile dropdown menu */}
      <Poppers
        open={Boolean(openProfile)}
        anchorEl={openProfile}
        transition
        disablePortal
        placement="bottom-end"
        className={`${classNames({ [classes.popperClose]: !openProfile })} ${classes.popperNav
          }`}
      >
        {({ TransitionProps }) => (
          <Grow
            {...TransitionProps}
            id="profile-menu-list-grow"
            style={{
              transformOrigin: "right",
            }}
          >
            <Paper>
              <ClickAwayListener
                onClickAway={() => {
                  setOpenProfile(null);
                }}
              >
                <MenuList role="menu">
                  <MenuItem
                    onClick={handleCloseProfile}
                    className={classes.dialogBoxDropDown}
                  >
                    Logout
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Poppers>

      {/* Session timeout modal */}
      <SessionOutModal
        open={openModal}
        logout={logoutFun}
        close={closeModal}
        remaining={remaining}
      />
    </div>
  );
}

// Defining prop types for the component
AdminNavbarLinks.propTypes = {
  userProvider: PropTypes.object,
  history: PropTypes.object,
  getUserListProvider: PropTypes.func,
  userRole: PropTypes.object,
  setState: PropTypes.func,
  logout: PropTypes.func,
  authLogout: PropTypes.func, // ===== OPTION B: Centralized logout action =====
  setOroviderListEmpty: PropTypes.func,
  resetReducer: PropTypes.func,
  menuData: PropTypes.object,
  app: PropTypes.any,
};

// Mapping Redux state to component props
const mapStateToProps = app => ({
  formData: app,
});

// ===== OPTION B: Add centralized logout action to dispatch =====
const mapDispatchToProps = {
  authLogout, // Centralized logout action for Option B
};

// Connecting the component to Redux
export default connect(mapStateToProps, mapDispatchToProps)(AdminNavbarLinks);
